<template>
    <div class="row mb-4">
        <div class="col-md-3 mb-4">
            <label class="form-label" for="is_publications">Is Publications</label>
            <select class="form-select" id="is_publications" v-model="filters.is_publications">
                <option value="">All</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
            </select>
        </div>
        <div class="col-md-3 mb-4">
            <label class="form-label" for="has_iplicit_product">Iplicit Product</label>
            <select class="form-select" id="has_iplicit_product" v-model="filters.has_iplicit_product">
                <option value="">All</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
            </select>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="input-group">
                <input type="text" class="form-control" v-model="searchTerm" placeholder="Search product SKU...">
                <span class="input-group-text bg-body border-0">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm" :filters="filters">
        <template #headings>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="name">Name</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="sku">Sku</sortableTh>
            <th>Is Publications?</th>
            <th>Iplicit Product</th>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="product in data" :key="product.id">
                <td>{{ product.name }}</td>
                <td>{{ product.sku }}</td>
                <td>
                    <i v-if="product.is_publications" class="fa fa-check text-success"></i>
                    <i v-else class="fa fa-times text-danger"></i>
                </td>
                <td>
                    <i v-if="product.has_iplicit_product" class="fa fa-check text-success"></i>
                    <i v-else class="fa fa-times text-danger"></i>
                </td>
                <td v-html="product.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { reactive, ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
});

const orderBy = ref('sku');
const orderAsc = ref(true);
const limit = ref(25);
const searchTerm = ref(null);
const filters = reactive({
    is_publications: '',
    has_iplicit_product: '',
});

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};
</script>
